//Material
import { Box } from "@mui/material";
//Interfaces and Types
import { TUserTextFieldProps } from "../../types/UserProfile";
import clsx from "clsx";

export default function UserTextField({ value, hasIcon = false }: Readonly<TUserTextFieldProps>) {
	return (
		<Box
			className={clsx({
				"!flex !pl-[12px] !font-sans !font-normal !bg-[var(--light-gray-color-v1)] !text-[14.5px] !text-[#00000061] !rounded-[6px] !h-[30px] !items-center !w-[100%]":
					true,
				"!ml-[25px]": hasIcon,
			})}
		>
			{value}
		</Box>
	);
}
